import loadView from "@/utils/load-view";

const routes = [
    // Public Path
    {
        path: "/learning/certificate/:certificateId",
        name: "LearningCertificate",
        component: loadView("LearningCertificate"),
        meta: {
            authRequired: false,
            resolvers: [
                to => ({
                    type: "learning/certificate/getCertificate",
                    payload: { certificateId: to.params.certificateId },
                }),
            ],
        },
    },

    {
        path: "/learn",
        redirect: "/learning",
    },

    {
        path: "/learning",
        redirect: "/learning/progress", // Automatically redirect to progress screen
        name: "Learning",
        component: loadView("Learning"),
        meta: {
            authRequired: true,
        },
        children: [
            //
            // Learning Progress
            //
            {
                path: "/learning/progress",
                name: "LearningProgress",
                component: loadView("LearningProgress"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "learning/progress/getList", payload: {} })],
                },
                children: [
                    {
                        path: "/learning/progress/:progressId/completed",
                        name: "LearningProgressCompletion",
                        component: loadView("LearningProgressCompletion"),
                        props: true,
                        meta: {
                            authRequired: true,
                            modal: true,
                        },
                    },
                    {
                        path: "/learning/progress/:progressId/:stepId",
                        name: "LearningProgressStepDetails",
                        component: loadView("LearningProgressStepDetails"),
                        props: true,
                        meta: {
                            authRequired: true,
                            modal: true,
                        },
                    },
                ],
            },

            //
            // My Library
            //
            {
                path: "/learning/library",
                name: "LearningLibraryPaths",
                component: loadView("LearningLibraryPaths"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "learning/library/getSelfenrolList", payload: {} })],
                },
            },
            {
                path: "/learning/library/archive",
                name: "LearningLibraryArchive",
                component: loadView("LearningLibraryArchive"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "learning/library/getList", payload: {} })],
                },
                children: [
                    {
                        path: "/learning/library/archive/element/:elementType/:elementId",
                        name: "LearningLibraryElementDetails",
                        component: loadView("LearningLibraryElementDetails"),
                        props: true,
                        meta: {
                            authRequired: true,
                            modal: true,
                            resolvers: [
                                to => ({
                                    type: "learning/library/getElement",
                                    payload: {
                                        id: to.params.elementId,
                                        type: to.params.elementType,
                                    },
                                }),
                            ],
                        },
                    },
                ],
            },

            //
            // Admin Element
            //
            {
                path: "/learning/admin/element",
                name: "LearningAdminElementList",
                component: loadView("LearningAdminElementList"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "learning/element/getList", payload: {} })],
                },
                children: [
                    {
                        path: "/learning/admin/element/new",
                        name: "LearningAdminElementNew",
                        component: loadView("LearningAdminElementEdit"),
                        meta: {
                            authRequired: true,
                            modal: true,
                            resolvers: [],
                        },
                    },
                    {
                        path: "/learning/admin/element/:elementType/:elementId/details",
                        name: "LearningAdminElementDetails",
                        component: loadView("LearningAdminElementDetails"),
                        props: true,
                        meta: {
                            authRequired: true,
                            modal: true,
                            resolvers: [
                                to => ({
                                    type: "learning/element/get",
                                    payload: {
                                        id: to.params.elementId,
                                        type: to.params.elementType,
                                    },
                                }),
                            ],
                        },
                    },
                    {
                        path: "/learning/admin/element/:elementType/:elementId/edit",
                        name: "LearningAdminElementEdit",
                        component: loadView("LearningAdminElementEdit"),
                        props: true,
                        meta: {
                            authRequired: true,
                            modal: true,
                            resolvers: [
                                to => ({
                                    type: "learning/element/get",
                                    payload: {
                                        id: to.params.elementId,
                                        type: to.params.elementType,
                                    },
                                }),
                            ],
                        },
                    },
                ],
            },

            //
            // Admin Path
            //
            {
                path: "/learning/admin/path",
                name: "LearningAdminPathList",
                component: loadView("LearningAdminPathList"),
                meta: {
                    authRequired: true,
                    resolvers: [() => ({ type: "learning/path/getList", payload: {} })],
                },
            },
            {
                path: "/learning/admin/path/:pathId/dashboard",
                name: "LearningAdminPathDashboard",
                component: loadView("LearningAdminPathDashboard"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => ({
                            type: "learning/path/get",
                            payload: { id: to.params.pathId, cache: true },
                        }),
                        to => ({
                            type: "learning/path/getStats",
                            payload: { id: to.params.pathId },
                        }),
                    ],
                },
                children: [
                    {
                        path: "/learning/admin/path/:pathId/dashboard/users/add",
                        name: "LearningAdminPathDashboardUserAdd",
                        component: loadView("LearningAdminPathDashboardUserAdd"),
                        props: true,
                        meta: {
                            authRequired: true,
                            modal: true,
                        },
                    },
                    {
                        path:
                            "/learning/admin/path/:pathId/dashboard/users/:userId/remove/:progressId",
                        name: "LearningAdminPathDashboardUserRemove",
                        component: loadView("LearningAdminPathDashboardUserRemove"),
                        props: true,
                        meta: {
                            authRequired: true,
                            modal: true,
                            resolvers: [
                                to => ({
                                    type: "users/details/get",
                                    payload: { id: to.params.userId },
                                }),
                            ],
                        },
                    },
                    {
                        path:
                            "/learning/admin/path/:pathId/dashboard/users/:userId/progress/:progressId",
                        name: "LearningAdminPathDashboardUserProgress",
                        component: loadView("LearningAdminPathDashboardUserProgress"),
                        props: true,
                        meta: {
                            authRequired: true,
                            modal: true,
                            resolvers: [
                                to => ({
                                    type: "users/details/get",
                                    payload: { id: to.params.userId },
                                }),
                                to => ({
                                    type: "learning/progress/get",
                                    payload: { id: to.params.progressId },
                                }),
                            ],
                        },
                    },
                ],
            },
            {
                path: "/learning/admin/path/:pathId/edit",
                name: "LearningAdminPathEdit",
                redirect(to) {
                    // If accessing to route details URL, redirect to the `basics` step
                    //
                    return `/learning/admin/path/${to.params.pathId}/edit/basics`;
                },
            },
            {
                path: "/learning/admin/path/:pathId/edit/:step",
                name: "LearningAdminPathEdit",
                component: loadView("LearningAdminPathEdit"),
                props: true,
                meta: {
                    authRequired: true,
                    resolvers: [
                        to => ({
                            type: "learning/path/get",
                            payload: {
                                id: to.params.pathId,
                                cache: true,
                            },
                        }),
                    ],
                },
                children: [
                    {
                        path: "/learning/admin/path/:pathId/edit/steps/add",
                        name: "LearningAdminPathEditStep",
                        component: loadView("LearningAdminPathEditStep"),
                        props: true,
                        meta: {
                            authRequired: true,
                            modal: true,
                            resolvers: [
                                () => ({
                                    type: "learning/element/getList",
                                    payload: {},
                                }),
                            ],
                        },
                    },
                    {
                        path:
                            "/learning/admin/path/:pathId/edit/steps/element/:elementType/:elementId/edit",
                        name: "LearningAdminElementEdit",
                        component: loadView("LearningAdminElementEdit"),
                        props: true,
                        meta: {
                            authRequired: true,
                            modal: true,
                            resolvers: [
                                to => ({
                                    type: "learning/element/get",
                                    payload: {
                                        id: to.params.elementId,
                                        type: to.params.elementType,
                                    },
                                }),
                            ],
                        },
                    },
                ],
            },
        ],
    },
];

export default routes;
